import { render, staticRenderFns } from "./Settings.vue?vue&type=template&id=7e0d7933&"
import script from "./Settings.vue?vue&type=script&lang=js&"
export * from "./Settings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e0d7933')) {
      api.createRecord('7e0d7933', component.options)
    } else {
      api.reload('7e0d7933', component.options)
    }
    module.hot.accept("./Settings.vue?vue&type=template&id=7e0d7933&", function () {
      api.rerender('7e0d7933', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/partners/Settings.vue"
export default component.exports